import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_TYPES = '@product/get-types';

export function getTypes() {
  const request = axios.get(`${API_BASE_URL}/product/type`);

  return (dispatch) => {
    request.then((response) =>
      dispatch({
        type: GET_TYPES,
        payload: { types: response.data }
      })
    );
  };
}
